import { useDispatch, useSelector } from "react-redux";

import { Button, Grid, Typography, List, ListItem } from "@mui/material";

import { bookingActions } from "../../../../store/reducers/booking";
import { uiActions } from "../../../../store/reducers/ui";
import constants from "../../../../utils/constants";
import BookingStep from "./BookingStep";

const generateCities = (branchesInfo) => {
  const cities = {};

  Object.keys(branchesInfo).forEach((branchCode) => {
    //If not remote
    if (branchCode !== "9999") {
      const branchInfo = branchesInfo[branchCode];

      if (!cities[branchInfo.city]) {
        cities[branchInfo.city] = {};
      }

      cities[branchInfo.city][branchCode] = {
        name: branchInfo.name,
        address: branchInfo.address,
        apptOnly: branchInfo.apptOnly,
      };
    }
  });

  return cities;
};

export default function Location() {
  const branchesInfo = useSelector((state) => state.booking.branchesInfo);
  const cities = generateCities(branchesInfo);

  const dispatch = useDispatch();

  const setSelectedBranch = (event) => {
    dispatch(bookingActions.updateClientDetails({ selectedBranch: event.target.value }));
    dispatch(uiActions.nextStep());
  };

  return (
    <BookingStep header={"default"}>
      <Grid container justifyContent="center" columnSpacing={2}>
        {Object.keys(cities).map((city) => {
          const branches = cities[city];

          return (
            (city === "Calgary" || city === "Edmonton") && (
              <Grid item xs={10} md={6} key={city}>
                <List>
                  <ListItem key={city} sx={{ display: "flex", justifyContent: "center" }}>
                    <Typography variant="h6" component="div">
                      {city}
                    </Typography>
                  </ListItem>
                  <Grid container direction="column">
                    {Object.keys(branches).map((branchCode) => {
                      const branch = branches[branchCode];

                      return (
                        <ListItem key={branchCode}>
                          {branch.apptOnly === 0 ? (
                            <>
                              <Button onClick={setSelectedBranch} variant="contained" value={branchCode} fullWidth>
                                {branch.address}
                              </Button>
                            </>
                          ) : (
                            <Grid container>
                              <Grid item xs>
                                {branch.address.toUpperCase()}
                              </Grid>
                              <Grid item xs>
                                <Typography variant="caption" display="block" gutterBottom>
                                  * By special request only. Call{" "}
                                  <a href={"tel:+" + constants.LITCO_NUMBER}>{constants.LITCO_NUMBER}</a> to book this
                                  location.
                                </Typography>
                              </Grid>
                            </Grid>
                          )}
                        </ListItem>
                      );
                    })}
                  </Grid>
                </List>
              </Grid>
            )
          );
        })}
      </Grid>
    </BookingStep>
  );
}
